module.exports = __webpack_public_path__ + "img/popup-game-sucai.16b57f9c.png";